export const HOMEPAGE_INTEGRATION_ICONS = {
  anthropic: '/img/icons/listicle/si-anthropic.svg',
  aws: '/img/icons/listicle/si-aws.svg',
  claude: '/img/icons/listicle/si-claude.svg',
  cursor: '/img/docs/cursor-icon.webp',
  gemini: '/img/icons/listicle/si-gemini.svg',
  groq: '/svgs/icons/LLMMonitoring/groq-logo.webp',
  opencode: '/svgs/icons/LLMMonitoring/opencode-logo.webp',
  openai: '/img/icons/listicle/si-openai.svg',
  openrouter: '/svgs/icons/LLMMonitoring/openrouter-logo.webp',
  vercel: '/img/icons/vercel-icon.svg',
} as const
